// Project portfolio — sourced from The Studio 31 company profile.
const img = (slug, i, caption) => ({ src: `/images/projects/${slug}-${i}.jpg`, caption });

export const PROJECTS = [
  {
    slug: "kailash-villa",
    name: "Kailash Villa",
    location: "Lucknow",
    category: "Residential",
    typology: "Private Villa",
    blurb:
      "A full-villa interior language built on warm travertine tones, slim brass reveals and sculptural relief walls.",
    shots: [
      "Living room with backlit stone media wall",
      "Lounge seating & layered textures",
      "Dining with brass pendant & mirror panelling",
      "Sculpted petal relief corridor",
      "Entrance console under the relief wall",
      "Guest washroom vanity",
    ],
  },
  {
    slug: "row-houses",
    name: "Row Houses",
    location: "Sector-52, Noida",
    category: "Residential",
    typology: "Row Houses",
    blurb:
      "Three row houses planned as one family cluster — glass partitions, soft pastels and statement chandeliers.",
    shots: [
      "Living & dining divided by a glass screen",
      "Dining with sculptural chandelier",
      "Mustard lounge with fluted timber wall",
      "Open living–dining in colour",
      "Mirror-clad foyer passage",
      "Art console & disc installation",
    ],
  },
  {
    slug: "ajnara-clock-tower",
    name: "Ajnara Clock Tower",
    location: "Noida",
    category: "Residential",
    typology: "Apartment Flats",
    blurb:
      "Apartment interiors with gold-trimmed wall mouldings, jaali screens and a tight, storage-first kitchen plan.",
    shots: [
      "Living room with gold moulding panels",
      "Dining behind a brass jaali screen",
      "Dining room in natural light",
      "Living room with teal accents",
      "Patterned-tile modular kitchen",
      "Kitchen with integrated appliances",
    ],
  },
  {
    slug: "dronacharya-apartments",
    name: "Dronacharya Apartments",
    location: "Mayur Vihar, Delhi",
    category: "Residential",
    typology: "Apartment Renovation",
    blurb:
      "A two-decade-old Delhi apartment rebuilt room by room — quirky constraints turned into bay seats and built-ins.",
    shots: [
      "Bay-window seat & marble foyer",
      "Children's room with star ceiling",
      "Kitchen with patterned backsplash",
      "Kitchen island & tall storage",
      "Passage with accent lighting",
      "Marble bath with backlit mirror",
    ],
  },
  {
    slug: "nagarjuna-apartments",
    name: "Nagarjuna Apartments",
    location: "Mayur Vihar, Delhi",
    category: "Residential",
    typology: "Apartment Interiors",
    blurb:
      "Compact apartment interiors — warm veneer, lit niches and a calm, uncluttered circulation spine.",
    shots: ["Lit niche console & kitchen view", "Passage to the private wing"],
  },
  {
    slug: "prateek-wisteria",
    name: "Prateek Wisteria",
    location: "Noida",
    category: "Residential",
    typology: "Apartment Flats",
    blurb:
      "A young family's apartment — playful children's rooms, a carved mandir wall and an efficient galley kitchen.",
    shots: [
      "Twin children's bedroom",
      "Master bedroom with timber headboard",
      "Backlit mandir wall",
      "Galley kitchen in graphite",
      "Study desk & open shelving",
      "Guest bathroom",
    ],
  },
  {
    slug: "mahagun-club",
    name: "Mahagun Club & Sample Flats",
    location: "Noida",
    category: "Residential",
    typology: "Club House & Sample Flats",
    blurb:
      "Club house and developer sample flats — jaali screens, inlay flooring and a repeatable luxury vocabulary.",
    shots: [
      "Club lobby with jaali screens",
      "Inlay flooring & double-height lobby",
      "Corridor in veneer and stone",
      "Sample flat living room",
      "Bedroom with mirrored wardrobe",
      "Vanity counter detail",
    ],
  },
  {
    slug: "babian-imperial-resort",
    name: "Babian Imperial Resort",
    location: "Lucknow",
    category: "Commercial",
    typology: "Resort · 36,000 sq.ft",
    blurb:
      "A 36,000 sq.ft resort taken from bare shell to banquet-ready — landscape, murals and ceremonial wall art.",
    shots: [
      "Landscaped lawn & jaali boundary",
      "Baraat wall with brass niches",
      "Hand-painted feature mural",
      "Buddha wall in a green court",
      "Open-air event lawn",
    ],
  },
  {
    slug: "ansal-housing",
    name: "Ansal Housing Corporate Office",
    location: "Sector-44, Gurgaon",
    category: "Commercial",
    typology: "Corporate Office · 6,000 sq.ft",
    blurb:
      "Corporate headquarters for Ansal Housing — a marble reception, laser-cut red screen and crisp meeting rooms.",
    shots: ["Marble reception desk", "Boardroom in red & chrome", "Reception with brand signage"],
  },
  {
    slug: "raina-towers",
    name: "Raina Tower Corporate Office",
    location: "Noida",
    category: "Commercial",
    typology: "Corporate Office · 8,000 sq.ft",
    blurb:
      "8,000 sq.ft of workplace — director cabins, acoustic conference room and open-plan workstation bays.",
    shots: [
      "Director cabin with fluted panelling",
      "Open-plan workstation bay",
      "Workstation rows with carpet tiles",
      "Conference room in timber",
    ],
  },
  {
    slug: "kailash-chikan",
    name: "Kailash Chikan Showroom",
    location: "Lucknow",
    category: "Commercial",
    typology: "Retail Showroom",
    blurb:
      "Retail for a heritage chikankari label — perforated white screens that let the fabric colour do the talking.",
    shots: ["Perforated screen facade & cash desk", "Showroom display floor"],
  },
];

export const PROJECT_CATEGORIES = ["All", "Residential", "Commercial"];

export const galleryOf = (p) =>
  p.shots.map((caption, i) => ({
    ...img(p.slug, i + 1, caption),
    alt: `${caption} — ${p.name}, ${p.location} by The Studio31`,
  }));

export const EXECUTED = {
  Commercial: [
    "ONGC Assam Asset Office, Nazira",
    "ONGC Golf Hut & Landscape, Assam",
    "Ansal Housing Corporate Office, Gurgaon",
    "Ansal Housing Commercial Arcade, Meerut",
    "Babian Group Resort, Lucknow",
    "Kailash Chikan Showroom, Lucknow",
    "Raina Tower Corporate Office, Noida",
  ],
  Residential: [
    "Ansal Housing Sample Flats, Pan India",
    "Mahagun Sample Flats & Club House",
    "Ajnara Clock Tower Flats, Noida",
    "Prateek Wisteria Flats, Noida",
    "Gulshan Vivante, Noida",
    "Nagarjuna Apartment, Delhi",
    "Dronacharya Apartment, Delhi",
    "Amar Colony Flat, Delhi",
    "Rama Group MD-Villa, Noida",
    "Villa & Row Houses, Lucknow",
  ],
};
